<div class="vadtallogin-page">
  <div class="container">
    <div class="row">
      
      <div class="col-lg-6 col-12 order-lg-0 order-2">
        <div class="login-content">
          <img src="../../../../assets/img/logo.svg" alt="logo" class="img-fluid loginlogo">
          <h3 class="caption-login mb-3">{{resetPasswordConstant.HEADER}}</h3>
          <p>{{resetPasswordConstant.HEADER_TEXT}}</p>
          <form class="mt-3" [formGroup]="recoverPasswordForm" (ngSubmit)="validateResetPassword()">
            <div class="form-group mb-4">
                <label>{{resetPasswordConstant.NEW_PASSWORD}}<span class="asterisk">*</span></label>
                <div class="input-group">
                  <input formControlName="newPassword" [type]="IsShowNewPassword ? 'text' : 'password'" class="form-control"  oninput="this.value = this.value.replace(/^\s+/g, '')" maxlength="15"  placeholder="Enter your new password" 
                  [ngClass]="{ 'is-invalid': submitted && recoverPasswordFormControl['newPassword'].errors }"/>
                  <div _ngcontent-fuk-c6="" class="input-group-append">
                    <div _ngcontent-fuk-c6="" class="input-group-text">
                        <span _ngcontent-fuk-c6="" [class]="IsShowNewPassword ? 'fa fa-eye-slash' :'fa fa-eye'" (click)="showNewPassword()"></span>
                    </div>
                  </div>
                </div>
                <span class="text-danger" *ngIf="submitted && recoverPasswordFormControl['newPassword'].errors?.['required']">{{errorMessageForPassword.NewPasswordRequired}}</span>
                  <span class="text-danger" *ngIf="submitted && recoverPasswordFormControl['newPassword'].errors?.['pattern']">{{errorMessageForPassword.PasswordPattern}}</span>
            </div>
            <div class="form-group mb-4">
                <label>{{resetPasswordConstant.CONFIRM_NEW_PASSWORD}}<span class="asterisk">*</span></label>
                <div class="input-group">
                  <input formControlName="confirmPassword"  [type]="IsShowOldPassword ? 'text' : 'password'" class="form-control"  oninput="this.value = this.value.replace(/^\s+/g, '')" maxlength="15"
                  placeholder="Enter your confirm new Password"
                  [ngClass]="{ 'is-invalid': submitted && recoverPasswordFormControl['confirmPassword'].errors }"/>                
                  <div _ngcontent-fuk-c6="" class="input-group-append">
                    <div _ngcontent-fuk-c6="" class="input-group-text">
                        <span _ngcontent-fuk-c6="" [class]="IsShowOldPassword ? 'fa fa-eye-slash' :'fa fa-eye'" (click)="showOldPassword()"></span>
                    </div>
                  </div>
                </div>
                <span class="text-danger" *ngIf="submitted && recoverPasswordFormControl['confirmPassword'].errors?.['required']">{{errorMessageForPassword.ConfirmNewPassword}}</span>
                  <span class="text-danger" *ngIf="submitted && recoverPasswordFormControl['confirmPassword'].errors?.['pattern']">{{errorMessageForPassword.PasswordPattern}}</span>
            </div>
            <button class="btn btn-primary login-btn mt-3 mb-3" type="submit">{{resetPasswordConstant.RESET_PASSWORD}}</button>
            <div class="backtologin text-center mt-3"><a (click)="goLogin()"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
            </svg>&nbsp;&nbsp;{{resetPasswordConstant.BACK_TO_LOGIN}}</a></div>
          </form>

        </div>
      </div>
      <div class="col-lg-6 col-12 order-lg-0 order-1">
        <div class="login-rightside">                    
            <img src="../../../../assets/img/login-rightimg.jpg" alt="login rightimg" class="img-fluid">
        </div>
      </div>

    </div>

  </div>



</div>